import { useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import useFcmTokenSync from "../hooks/useFcmTokenSync";
import useMessages from "../hooks/useMessages";
import { updateFcmSyncStatus } from "../services/profileService";
import usePushStatusStore, { selectSetPushStatus } from "../store/usePushStatusStore";

export default function FcmTokenManager() {
  const { currentUser } = useAuth();
  const { token, error, permission, revalidation, requestToken } = useMessages(
    Boolean(currentUser?.uid),
    { autoRequest: false }
  );

  const setPushStatus = usePushStatusStore(selectSetPushStatus);

  useFcmTokenSync(token, currentUser, revalidation);

  useEffect(() => {
    setPushStatus({ permission, hasToken: Boolean(token), error });
  }, [error, permission, setPushStatus, token]);

  useEffect(() => {
    const handleNotificationRequest = () => {
      requestToken({ prompt: true });
    };

    window.addEventListener("inssa:request-notifications", handleNotificationRequest);
    return () => {
      window.removeEventListener("inssa:request-notifications", handleNotificationRequest);
    };
  }, [requestToken]);

  useEffect(() => {
    if (!currentUser?.uid || !error) return;

    updateFcmSyncStatus(currentUser.uid, {
      state: "token_error",
      permission: permission || "unknown",
      errorMessage: error,
    }).catch((statusError) => {
      console.warn("Failed to save FCM sync status.", statusError);
    });
  }, [currentUser?.uid, error, permission]);

  return null;
}
